export default "__VITE_ASSET__CzDJBmyF__"